import { encodeSlug } from './encode-slug';
import { prefixLocale } from './prefix-locale';

export function buildCollectionPath(slug: string, locale?: string): string {
  return prefixLocale(`/collection/${encodeSlug(slug)}`, locale);
}
